import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { defineComponent as _defineComponent } from 'vue';
import { goodsInfoInjectionKey } from '@/shared/injections';
import SATracking from '@/shared/saTracking';
import { computed, inject, useAttrs, useListeners, watch, nextTick } from 'vue';
var __default__ = {
    inheritAttrs: false
};
export default /*#__PURE__*/ _defineComponent(_object_spread_props(_object_spread({}, __default__), {
    __name: 'nav-bar-with-tracking',
    emits: [
        "click-left"
    ],
    setup: function setup(__props, param) {
        var emit = param.emit;
        var goodsInfo = inject(goodsInfoInjectionKey, {});
        var onClickLeft = function onClickLeft(event) {
            if (event.target) {
                SATracking.trackClick(event.target, {
                    desc: '返回',
                    describe: SATracking.serialize({
                        page_status: goodsInfo.status
                    })
                });
            }
            emit('click-left', event);
        };
        var listeners = useListeners();
        var attrs = useAttrs();
        var navbarListeners = computed(function() {
            return _object_spread_props(_object_spread({}, listeners), {
                'click-left': onClickLeft
            });
        });
        watch(function() {
            return attrs.title;
        }, function(newVal) {
            if (newVal && typeof newVal === 'string') {
                nextTick(function() {
                    document.title = newVal;
                });
            }
        }, {
            immediate: true
        });
        return {
            __sfc: true,
            emit: emit,
            goodsInfo: goodsInfo,
            onClickLeft: onClickLeft,
            listeners: listeners,
            attrs: attrs,
            navbarListeners: navbarListeners
        };
    }
}));
